export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img src="/brand/logo.webp" alt="InstantTCGZ logo" className={`${className} rounded-full object-cover shadow-[0_0_24px_-4px_rgba(63,208,255,0.6)]`} />
);

export const Wordmark = () => (
  <span className="font-display text-lg font-extrabold tracking-tight">
    INSTANT<span className="text-volt">TCGZ</span>
  </span>
);
